import Link, {LinkProps} from "@mui/material/Link"
import Typography, {TypographyProps} from "@mui/material/Typography"
import React from "react"
import {AvantColors} from "./AvantColors"

export const H1Text = (props: TypographyProps) => (
    <Typography variant={"h1"} {...props}/>
)
export const H2Text = (props: TypographyProps) => (
    <Typography variant={"h2"} {...props}/>
)
export const H3Text = (props: TypographyProps) => (
    <Typography variant={"h3"} {...props}/>
)
export const H4Text = (props: TypographyProps) => (
    <Typography variant={"h4"} {...props}/>
)
export const H5Text = (props: TypographyProps) => (
    <Typography variant={"h5"} {...props}/>
)
export const H6Text = (props: TypographyProps) => (
    <Typography variant={"h6"} {...props}/>
)
export const LabelText = (props: TypographyProps) => (
    <Typography variant={"subtitle1"} {...props}/>
)
export const SmallLabelText = (props: TypographyProps) => (
    <Typography variant={"subtitle2"} {...props}/>
)
export const MicroLabelText = (props: TypographyProps) => (
    <Typography variant={"caption"} {...props}/>
)
export const BodyText = (props: TypographyProps) => (
    <Typography variant={"body1"} {...props}/>
)

export const WritingResponseText = (props: TypographyProps) => (
    <BodyText style={{whiteSpace: "pre-line"}} {...props}/>
)

export const RTLWritingResponseText = (props: TypographyProps) => (
    <BodyText style={{
        direction: "rtl",
        unicodeBidi: "bidi-override",
        whiteSpace: "pre-line",
        textAlign: "right"
    }} {...props}/>
)

export const SmallBodyText = (props: TypographyProps & {}) => (
    <Typography variant={"body2"} {...props}/>
)
export const MicroText = (props: TypographyProps) => {
    const {style, ...rest} = props
    return <Typography variant={"caption"}
                            style={{fontSize: 10, lineHeight: "10px", textTransform: "none", ...style}} {...rest}/>
}

export const ErrorText = (props: TypographyProps) => <Typography color={"error"} variant={"body1"} {...props}/>

/** @deprecated Please don't put margin on global, reusable components, use `ErrorText` instead. */
export const ErrorBody = (props: TypographyProps) => {
    const {style, ...rest} = props
    return (<Typography variant={"body1"} style={{marginBottom: "5px"}} {...rest}/>)
}

export const ErrorTitle = (props: TypographyProps) => {
    const {style, ...rest} = props
    return (
        <Typography
            variant={"h2"}
            style={{
                color: AvantColors.REPORT_FONT_COLOR_GRAY_1,
                fontWeight: "lighter",
                margin: "30px 0 30px 0",
                fontSize: "30px",
                textAlign: "center",
                ...style
            }}
            {...rest}
        />
    )
}


export const LinkText = (props: LinkProps & { disabled?: boolean }) => {
    const {style, disabled, children, ...rest} = props
    if (disabled) {
        return <SmallBodyText children={children} style={{color: "#CDCDCD", ...style}}/>
    }
    return <Link style={{...style}} children={children} {...rest}/>
}
